export default interface IEPGUpdateExecutorManageModel {
    execute(): Promise<void>;
}
